/**
 * GPS acquisition options for clock-in/out capture, declared side by side so
 * the platforms' tradeoffs stay deliberate rather than accidental drift:
 *
 * - Native uses high accuracy with a short cache: punches are the primary
 *   mobile use case and shop-floor GPS is the geofence evidence.
 * - Web trades accuracy for speed (desktop browsers often lack GPS hardware
 *   and prompt latency dominates), but the cache is capped at 60s — a
 *   5-minute-old fix was stale enough to pass/fail a geofence wrongly.
 */
export const NATIVE_GPS_OPTIONS = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 10000,
};
export const WEB_GPS_OPTIONS = {
    enableHighAccuracy: false,
    timeout: 3000,
    maximumAge: 60000,
};
/**
 * Hard wall-clock ceiling on a web location read, covering what the spec
 * `timeout` above does NOT: the permission-prompt phase. The W3C timeout
 * only starts once permission is granted, so a browser that never answers —
 * a prompt the user ignores, a privacy browser whose geolocation is a
 * no-op stub — invokes NEITHER callback and the read waits forever (the
 * check-in button spun indefinitely on such browsers). 10s is long enough
 * to read and answer a real prompt; past it the read resolves as a timeout
 * failure and the caller shows its retry guidance.
 */
export const WEB_GPS_HARD_TIMEOUT_MS = 10000;
